// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"numbers-8-1"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15C16 12.7909 14.2091 11 12 11ZM12 11C13.7949 11 15.25 9.54493 15.25 7.75C15.25 5.95507 13.7949 4.5 12 4.5C10.2051 4.5 8.75 5.95507 8.75 7.75C8.75 9.54493 10.2051 11 12 11Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-numbers-8-1')
export default class Numbers81Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'numbers-8-1',
    }
  }
}
